export default __webpack_public_path__ + "static/media/Levitate D3.2 Methods for forecasting the impacts of connected and automated vehicles.1e22a9ea.pdf";